import moment from 'moment';

class HubComment {
  hubCommentId = 0;
  hubId = 0;
  commentDate = moment().format('YYYY-MM-DD 00:00:00.000');
  textValue = '';
  allowAdd = true;
  allowRemove = true;
  status = '';

  constructor(obj) {
    obj && Object.assign(this, obj);
  }
}

export { HubComment };